/*
 * Copyright 2025 Intuition Robotics ltd
 */
export type DB_Task = {
	_id: string,
	executionTimestamp: number,
	finishedAt?: number,
	createdAt: number,
	moduleName: string,
	methodName: string,
	methodParams: any[],
	status: TaskStatus
}

export enum StatusType {
	ToBeExecuted = "ToBeExecuted",
	InProgress = "InProgress",
	Completed = "Completed",
	Error = "Error"
}

export type TaskStatus = {
	status: StatusType,
	retries:number,
	maxRetries: number,
	debugError?: string
}
